var _defs, _circle, _circle2, _circle3, _circle4, _text, _rect, _circle5, _text2, _rect2, _circle6, _text3, _rect3, _circle7, _text4, _rect4, _circle8, _text5, _path, _circle9, _circle0, _circle1, _circle10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutAndusHeroPeopleProcessDataSystemOrbitMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 360,
    height: 470,
    viewBox: "0 0 360 470",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "People, processes, data and systems connected around applied intelligence") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "aboutHeroGlow"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BCBFF",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD0E2",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aboutHeroRing"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#8BCBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2775"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 230,
    r: 190,
    fill: "url(#aboutHeroGlow)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 230,
    r: 132,
    fill: "none",
    stroke: "#8BCBFF",
    strokeOpacity: 0.52
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 230,
    r: 91,
    fill: "none",
    stroke: "#FF91BA",
    strokeOpacity: 0.34,
    strokeDasharray: "4 8"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 230,
    r: 63,
    fill: "#07152A",
    stroke: "url(#aboutHeroRing)",
    strokeWidth: 3
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 222,
    fill: "#FFFFFF",
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 15,
    fontWeight: 850,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 180,
    dy: 0
  }, "APPLIED"), /*#__PURE__*/React.createElement("tspan", {
    x: 180,
    dy: 19
  }, "INTELLIGENCE"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 34,
    width: 142,
    height: 62,
    rx: 15,
    fill: "#FFFFFF",
    fillOpacity: 0.93,
    stroke: "#C9DDF1"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 65,
    r: 7,
    fill: "#087CFF"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 61,
    fill: "#07152A",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 800,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 56,
    dy: 0
  }, "PEOPLE"), /*#__PURE__*/React.createElement("tspan", {
    x: 56,
    dy: 15
  }, "Roles and decisions"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 34,
    width: 142,
    height: 62,
    rx: 15,
    fill: "#FFFFFF",
    fillOpacity: 0.93,
    stroke: "#C9DDF1"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 65,
    r: 7,
    fill: "#FF2775"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 242,
    y: 61,
    fill: "#07152A",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 800,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 242,
    dy: 0
  }, "PROCESS"), /*#__PURE__*/React.createElement("tspan", {
    x: 242,
    dy: 15
  }, "Flow and controls"))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 374,
    width: 142,
    height: 62,
    rx: 15,
    fill: "#FFFFFF",
    fillOpacity: 0.93,
    stroke: "#C9DDF1"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 405,
    r: 7,
    fill: "#30D6A1"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 401,
    fill: "#07152A",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 800,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 56,
    dy: 0
  }, "DATA"), /*#__PURE__*/React.createElement("tspan", {
    x: 56,
    dy: 15
  }, "Evidence and insight"))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 374,
    width: 142,
    height: 62,
    rx: 15,
    fill: "#FFFFFF",
    fillOpacity: 0.93,
    stroke: "#C9DDF1"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 225,
    cy: 405,
    r: 7,
    fill: "#F4B63D"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 242,
    y: 401,
    fill: "#07152A",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 800,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 242,
    dy: 0
  }, "SYSTEMS"), /*#__PURE__*/React.createElement("tspan", {
    x: 242,
    dy: 15
  }, "Tools and integration"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158 96 Q145 138 156 169       M202 96 Q215 138 204 169       M158 374 Q142 325 153 290       M202 374 Q218 325 207 290",
    fill: "none",
    stroke: "#4A9BE4",
    strokeWidth: 2,
    strokeDasharray: "4 7"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 96,
    r: 4,
    fill: "#087CFF"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 96,
    r: 4,
    fill: "#FF2775"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 374,
    r: 4,
    fill: "#30D6A1"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 374,
    r: 4,
    fill: "#F4B63D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutAndusHeroPeopleProcessDataSystemOrbitMobile);
export default __webpack_public_path__ + "static/media/about-andus-hero-people-process-data-system-orbit-mobile.ca381cd45e22469eb27f3c9d1c5e9b51.svg";
export { ForwardRef as ReactComponent };